<template>
  <div style="background-color: #f5f5f5; overflow: hidden; padding-top: 0.7rem">
    <!-- 上传作品 -->
    <div class="uploadFilesBox comBox" v-if="percentageValue == 0 || percentageValue != 100 || jpimg.length != 10"
      v-loading="loading">
      <el-upload vclass="upload-demo" drag action="#" :auto-upload="false" :show-file-list="false"
        :on-change="handleChange">
        <el-icon class="el-icon--upload"><upload-filled /></el-icon>
        <div class="el-upload__text">
          <div class="uploadFiles_content_1">拖拽视频文件到此处开始上传</div>
          <div class="uploadFiles_content_2">
            视频作品仅用于个人展示，不涉及商业用途，请确保作品自己参与，无需商业版权
          </div>
        </div>
        <div class="uploadFiles_content_3">点击选择文件</div>
        <div class="uploadFiles_content_4">
          仅支持MP4/MOV/AVI格式，单个文件大小不超过10G
        </div>
      </el-upload>
    </div>
    <uploadData v-else :jpimg="jpimg" :percentageValue="percentageValue" :filePath="filePath" :fileName="fileName">
    </uploadData>

    <div v-if="imgs" style="position: fixed;left: 0;top: 0px;z-index: -99;">
      <video :src="imgs" controls autoplay muted id="video3"></video>
      <canvas id="myCanvas"></canvas>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useRouter } from "vue-router";
import { ref, nextTick } from "vue";
import uploadByPieces from "@/assets/js/uploadNew";
import { ElMessage } from "element-plus";
import uploadData from "./upload_data.vue";
const router = useRouter();
const percentageValue = ref<number>(0);
const filePath = ref("");
const fileName = ref("");
const loading = ref(false);
const imgs: any = ref("");

const capture = () => {
  nextTick(() => {
    // 获取video和canvas元素
    const video: any = document.getElementById('video3');
    const canvas: any = document.getElementById('myCanvas');
    // console.log(video, canvas)    // 设置canvas尺寸与video一致
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    // 获取canvas的2d绘图上下文
    const context = canvas.getContext('2d');
    // 将当前video帧绘制到canvas上
    context.drawImage(video, 0, 0, canvas.width, canvas.height);

    // 将canvas内容转换为data URL，即Base64编码的图像
    const imageDataUrl = canvas.toDataURL('image/png');
    jpimg.value.push(imageDataUrl);
    console.log(jpimg.value)
  })

}
const allowedExtensions = ref([".mp4", ".mov", ".avi"]);
let im___: any;
const jpimg: any = ref([]);
const handleChange = async (uploadFile: any, uploadFiles: any) => {
  if (
    allowedExtensions.value.indexOf(
      uploadFile.name
        .substring(uploadFile.name.lastIndexOf("."))
        .toLocaleLowerCase()
    ) == -1
  ) {
    ElMessage.warning("格式不正确");
    return;
  }
  loading.value = true;
  const timestamp = Date.now();
  percentageValue.value = 0;
  fileName.value = uploadFile.name;
  imgs.value = await file_base(uploadFile.raw);
  jpimg.value = [];
  clearInterval(im___);
  im___ = setInterval(() => {
    if (jpimg.value.length == 10) {
      clearInterval(im___);
      loading.value = false;
      return
    }
    capture()
  }, 2000);
  uploadByPieces(
    timestamp,
    uploadFile.raw,
    5,
    3,
    (res: any) => {
      percentageValue.value = 100;
      filePath.value = res.data.url;

    },
    (p: any) => {
      percentageValue.value = p;
    },
    (error: any) => {
      console.error(error);
    }
  );
};
const file_base = async (file: any) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}
</script>

<style scoped lang="less">
@import url("/src/assets/css/com.css");

.uploadFilesBox {
  height: 5.72rem;
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
  opacity: 1;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin: 28px auto 33px;
}

.uploadFiles_content_1 {
  font-size: 0.32rem;
  font-weight: 400;
  color: #86909c;
  line-height: 36px;
  text-align: center;
}

.uploadFiles_content_2 {
  font-size: 0.14rem;
  font-weight: 400;
  color: #86909c;
  line-height: 16px;
  margin: 15px 0 30px;
  text-align: center;
}

.uploadFiles_content_3 {
  width: 2.04rem;
  height: 0.53rem;
  line-height: 0.53rem;
  margin: 0 auto;
  background: #c01a26;
  border-radius: 0.6875rem;
  opacity: 1;
  font-size: 0.14rem;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  margin-bottom: 15px;
}

.uploadFiles_content_4 {
  font-size: 0.12rem;
  text-align: center;
  font-weight: 400;
  color: #86909c;
  line-height: 13px;
}

/deep/.el-upload-dragger {
  border: 0;
}

/deep/ input[type="file"] {
  display: none;
}

/deep/ .el-upload__input {
  display: none;
}

/deep/.el-form-item.is-success .el-input__suffix-inner {
  color: #67C23A !important;
}

/deep/.el-form-item.is-success .el-input__suffix-inner {
  color: #67C23A !important;
}

/deep/.el-form-item.is-success .el-select__suffix {
  color: #67C23A !important;
}
</style>
